// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import useDataTransform from './useDataTransform'
import useDataOnChange from './useDataOnChange'
import rdata from './data.json'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function PatientsListData(props) {
  let data = useDataTransform(props, rdata.value)
  let onChange = useDataOnChange(props, data)

  return (
    <DataProvider
      context="tab"
      value={data}
      viewPath={props.viewPath}
      onChange={onChange}
    >
      <View {...props} />
    </DataProvider>
  )
}